import { render, staticRenderFns } from "./distributor-interview.vue?vue&type=template&id=12c60173&scoped=true&"
import script from "./distributor-interview.vue?vue&type=script&setup=true&lang=js&"
export * from "./distributor-interview.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./distributor-interview.vue?vue&type=style&index=0&id=12c60173&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c60173",
  null
  
)

export default component.exports